import type {FullCourseLevel} from "@repo/sanity-utils/query-types";

type SelectedModalityOffering = NonNullable<
	NonNullable<FullCourseLevel>["modalityOfferings"]
>[number];

/**
 * Append a campus query parameter to a URL.
 */
export function appendCampusQueryParameter(
	url: string,
	campusId: string | null
) {
	if (!campusId) {
		return url;
	}

	try {
		const parsedUrl = new URL(url);
		parsedUrl.searchParams.set("campus", campusId);
		return parsedUrl.toString();
	} catch {
		return url;
	}
}

/**
 * Append a modality-specific schedule anchor to a course URL.
 */
export function appendScheduleAnchor(url: string, modalityName: string) {
	switch (modalityName) {
		case "video-based":
			return `${url}#schedule`;
		case "chat-based":
			return `${url}#course-schedule`;
		case "in-person":
			return `${url}#available-sessions`;
		default:
			return url;
	}
}

/**
 * Build a consultation URL with a campus query parameter.
 * Video-based modalities use the Zoom scheduler instead of contact-us.
 */
export function buildConsultationUrl(
	academyUrl: string,
	campusId: string | null,
	selectedModalityOffering?: SelectedModalityOffering | null
) {
	if (selectedModalityOffering?.modality?.slug?.current === "video-based") {
		return "https://scheduler.zoom.us/d/gmzq1cj7/aops-consultation";
	}

	const baseUrl = academyUrl.replace(/\/+$/, "");
	return appendCampusQueryParameter(`${baseUrl}/contact-us`, campusId);
}

/**
 * Build the AoPS placement test URL.
 */
export function buildPlacementTestUrl(aopsUrl: string) {
	const baseUrl = aopsUrl.replace(/\/+$/, "");
	return `${baseUrl}/placement`;
}
